import { Component, Inject, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { forkJoin } from "rxjs";
import { GlobalVariable } from "../../app.component";
import { DataService } from "../../dataService/data.service";

// import { AngularFontAwesomeComponent } from 'angular-font-awesome';

@Component({
  selector: "app-analytics-invite-rate-reviews",
  templateUrl: "./analytics-invite-rate-reviews.component.html",
  styleUrls: ["./analytics-invite-rate-reviews.component.scss"],
})
export class AnalyticsInviteRateReviewsComponent implements OnInit {
  gaugeType = "full";
  gaugeValue = 55;
  gaugeLabel = "Invites Sent";
  gaugeAppendText = "";

  private BASE_URL = GlobalVariable;
  outlet_id: string;
  review_sent: any;
  review_click: any;
  review_percent: any;
  progress_style: any;

  constructor(
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private HttpService: DataService,
    private router: Router,
    private toastrService: ToastrService
  ) {}

  ngOnInit() {
    this.outlet_id = this.storage.get("outlet_id");

    const res_sent = this.HttpService.get(
      this.BASE_URL.INVITE_SEND_URL(this.outlet_id)
    );
    const res_click = this.HttpService.get(
      this.BASE_URL.INVITE_CLICKED_URL,
      this.outlet_id
    );

    forkJoin([res_sent, res_click]).subscribe(
      (results) => {
        this.review_sent = results[0].data["sent_count"];
        this.review_click = results[1].data["clicked_count"];
        //console.log(this.review_percent);
        if (isNaN(this.review_percent)) {
          this.review_percent = 0;
        } else {
          this.review_percent = Math.round(
            (this.review_click / this.review_sent) * 100
          );
        }
        this.progress_style = {
          "background-color": "#03c0c2",
          "border-radius": "20px",
          width: Math.round(this.review_percent) + "%",
        };
      },
      (error) => {
        this.showError(error.error.message);
      }
    );
  }

  /**
   *Common toastr for success function
   *
   * @param {string} msg
   * @memberof AnalyticsInviteRateReviewsComponent
   */
  showSuccess(msg: string) {
    this.toastrService.success(msg);
  }

  /**
   * Common toastr for error function
   *
   * @param {string} msg
   * @memberof AnalyticsInviteRateReviewsComponent
   */
  showError(msg: string) {
    this.toastrService.error(msg);
  }
}
